import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular'
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
	imports: [IonicModule, DirectivesModule],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts